<!-- 角色管理 -->
<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">角色名称：</span>
        <el-input v-model="roleName" clearable placeholder="请输入角色名称" :size="size"></el-input>
      </div>
      <div class="header_item">
        <el-button :size="size" icon="el-icon-search"  v-if="showButton('search')" @click="searchRoleInfo(true)">查询</el-button>
        <el-button class="search_btn" icon="el-icon-plus" v-if="showButton('insert')" @click="propInsert()">添加</el-button>
        <el-button :size="size" v-if="showButton('configRoot')" @click="propConfig()">配置权限</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        :data="roleList"
        height="100%"
        v-loading="loading">
        <el-table-column label="序号" width="55" align="center">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="roleName" label="角色名称" align="center"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="propUpdate(row)">修改</el-button>
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteRoleInfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 添加 修改角色信息 -->
    <el-dialog
      :title="asyncTitle === 0 ? '添加角色信息' : '修改角色信息'"
      :visible.sync="asyncRole"
      width="35%"
      class="prop_dialog">
      <el-form ref="form" class="rule_form" :model="ruleForm" :rules="rules" label-width="100px">
        <el-form-item label="角色名称：" prop="roleName">
          <el-input v-model="ruleForm.roleName" clearable :size="size" placeholder="请输入角色名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncRole = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle === 0 ? submitInsert() : submitUpdate()"> 提 交</el-button>
      </div>
    </el-dialog>
    <!-- 配置角色信息 -->
    <el-dialog
      class="prop_dialog"
      title="配置角色信息"
      :visible.sync="asyncConfig"
      width="35%">
      <div class="dialog_flex rule_form">
        <div class="flex_left">
          <span class="flex_title">角色列表：</span>
          <el-radio-group class="left_group" v-model="rideoRoleId">
            <template v-for="item in roleRideoList">
              <el-radio class="item" :key="item.roleId" :label="item.roleId" @change="changeRole">{{item.roleName}}</el-radio>
            </template>
          </el-radio-group>
        </div>
        <div class="flex_light">
          <span class="flex_title">菜单列表：</span>
          <el-tree
            ref="tree"
            node-key="menuId"
            :data="menusList"
            show-checkbox
            default-expand-all
            highlight-current
            :props="menusProps">
          </el-tree>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="asyncConfig = false">取 消</el-button>
        <el-button class="submit_btn" @click="submitRoleMenu()"> 提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buttonPinia } from '../../pinia/index';
import { throttle, changeSize } from '../../plugins/public'; // 导入节流、动态切换组件尺寸方法
  export default {
    data() {
      return {
        size: changeSize(),
        roleName: '', // 角色名称
        pageNum: 1,
        pageSize: 10,
        total: 0,
        loading: true,
        roleList: [], // 角色列表信息
        asyncTitle: 0, // 弹出框标题 0: 添加角色信息，1：修改角色信息
        asyncRole: false, // 角色弹出框变量
        ruleForm: {}, // 角色信息
        urlForm: {},
        rules: {
          roleName: [{
            required: true, 
            message:'请输入角色名称', 
            trigger: 'blur'
          }]
        },
        roleRideoList: [], // 所有角色信息
        asyncConfig: false, // 配置角色信息弹出框
        rideoRoleId: "", // 选择角色信息
        menusList: [], // 菜单列表信息
        menusProps: {
          children: "childrens",
          label: "label"
        }
      }
    },
    watch: {
      asyncRole(bol) {
        if(!bol) {
          this.ruleForm = {};
          this.$refs.form.resetFields();
        }
      },
      asyncConfig(bol) {
        if(!bol) {
          this.rideoRoleId = "";
          this.roleRideoList = [];
          this.menusList = [];
        }
      },
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchRoleInfo(true);
    },
    methods: {
      // 获取角色信息
      async getRoleInfo() {
        const { data } = await this.$api.System.getAllRolesInfo({})
        this.roleRideoList = data;
      },
      // 查询角色列表信息
      searchRoleInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = {
          roleName: this.roleName,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
        this.loading = true;
        this.$api.System.searchRoleInfo(params).then(res => {
          if(res.statusMsg === 'ok') {
            this.total = res.data.total;
            this.roleList = res.data.list;
          }
          this.loading = false;
        })
      },
      // 打开添加角色信息
      propInsert() {
        this.asyncTitle = 0;
        this.asyncRole = true;
      },
      // 打开修改角色信息
      propUpdate(row) {
        this.asyncTitle = 1;
        this.asyncRole = true;
        this.$set(this.ruleForm, 'roleId', row.roleId);
        this.$set(this.ruleForm, 'roleName', row.roleName);
        this.$set(this.ruleForm, 'version', row.version);
      },
      // 打开配置角色权限
      propConfig() {
        this.getRoleInfo();
        this.rideoRoleId = this.roleList[0].roleId;
        this.$api.System.getRoleInfoMenus({
          roleId: this.rideoRoleId
        }).then((res) => {
          if(res.statusMsg === 'ok') {
            this.menusList = this.disposeMenus(res.data);
            this.$nextTick(() => {
              this.disposeMenusRadio(res.data);
            });
          }
        })
        this.asyncConfig = true;
      },
      // 删除角色信息
      deleteRoleInfo(row) {
        this.$confirm("该操作将删除该角色，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.System.deleteRoleInfo({id: row.roleId})
        .then(res => {
          if(res.statusMsg === 'ok') {
            this.searchRoleInfo(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 提交添加角色信息
      submitInsert: throttle(function() {
        this.$refs.form.validate(valid => {
          if(valid) {
            let params = Object.assign({}, this.ruleForm);
            this.$api.System.createRoleInfo(params).then(res => {
              if(res.statusMsg === 'ok') {
                this.asyncRole = false;
                this.searchRoleInfo(true);
                this.$message.success("添加成功！");
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改角色信息
      submitUpdate: throttle(function() {
        this.$refs.form.validate(valid => {
          if(valid) {
            let params = Object.assign({}, this.ruleForm);
            this.$api.System.updateRoleInfo(params).then(res => {
              if(res.statusMsg === 'ok') {
                this.asyncRole = false;
                this.searchRoleInfo(true);
                this.$message.success("修改成功！");
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交配置角色权限信息
      submitRoleMenu: throttle(function() {
        const list = [...this.$refs.tree.getCheckedKeys(),...this.$refs.tree.getHalfCheckedKeys()];
        this.$api.System.configRoleMenusInfo({
          roleId: this.rideoRoleId,
          menuIds: list.join(',')
        }).then(res => {
          if(res.statusMsg === 'ok') {
            this.asyncConfig = false;
            this.$message.success('配置成功！');
          }else {
            this.$message.warning(res.statusMsg);
          }
        })
      }, 3000),
      // 选择角色查询所有权限
      changeRole(data) {
        this.$refs.tree.setCheckedNodes([]);
        this.$api.System.getRoleInfoMenus({roleId: data})
        .then((res) => {
          this.$nextTick(() => {
            this.disposeMenusRadio(res.data);
          });
        })
      },
      // 处理菜单选中信息
      disposeMenusRadio(list) {
        list.forEach(item => {
          if(item.rolehas === 1) {
            this.$refs.tree.setChecked(item, true, false);
          }
          if(item.childrens&&item.childrens.length > 0) {
            this.disposeMenusRadio(item.childrens);
          }
        })
      },
      // 处理菜单信息
      disposeMenus(list) {
        const data = list.map(item => {
          this.$set(item, 'label', item.title);
          this.$set(item, 'id', item.menuId);
          if(item.childrens&&item.childrens?.length > 0) {
            this.$set(item, 'children', this.disposeMenus(item.childrens));
          }
          return item
        })
        return data;
      },
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },
      // 切换分页
      changePageNum(page) {
        this.pageNum = page;
        this.searchRoleInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchRoleInfo();
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../style/layout-main.scss';
  .dialog_flex {
    display: flex;
    justify-content: space-around;

    .flex_title {
      color: #fff;
      display: inline-block;
      padding: 10px 0;
      font-size: 16px;
    }

    .flex_left {
      text-align: center;

      .left_group {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .item {
          margin: 5px 0;
        }
      }
    }

    .flex_light {
      text-align: center;
    }
  }
</style>
